/**
 * Curated emoji set with shortcodes for the picker, `:shortcode:` autocomplete
 * and rendering. Format per entry: "emoji shortcode [extra keywords…]".
 */
const RAW: Record<string, string[]> = {
  Smileys: [
    '😀 grinning happy smile', '😃 smiley happy', '😄 smile happy joy', '😁 grin', '😆 laughing lol', '😅 sweat_smile phew', '🤣 rofl lol',
    '😂 joy lol tears', '🙂 slight_smile', '🙃 upside_down', '😉 wink', '😊 blush', '😇 innocent angel', '🥰 smiling_hearts love',
    '😍 heart_eyes love', '🤩 star_struck wow', '😘 kiss', '😋 yum tasty', '😛 tongue', '😜 wink_tongue', '🤪 zany crazy', '🤑 money_mouth',
    '🤗 hug', '🤭 hand_over_mouth oops', '🤫 shush quiet', '🤔 thinking hmm', '🤐 zipper_mouth', '🤨 raised_eyebrow sus', '😐 neutral',
    '😑 expressionless', '😶 no_mouth', '😏 smirk', '😒 unamused', '🙄 eye_roll', '😬 grimace awkward', '😌 relieved', '😔 pensive',
    '😪 sleepy', '😴 sleeping zzz', '😷 mask sick', '🤒 thermometer sick', '🤢 nauseated', '🤮 vomit', '🥵 hot', '🥶 cold freezing',
    '🥴 woozy', '😵 dizzy', '🤯 exploding_head mindblown', '🤠 cowboy', '🥳 partying party', '😎 sunglasses cool', '🤓 nerd',
    '🧐 monocle', '😕 confused', '😟 worried', '🙁 frown', '😮 open_mouth wow', '😲 astonished', '😳 flushed', '🥺 pleading puppy',
    '😦 frowning', '😨 fearful', '😰 anxious', '😥 sad_relieved', '😢 cry sad', '😭 sob crying', '😱 scream', '😖 confounded',
    '😣 persevere', '😞 disappointed', '😓 sweat', '😩 weary', '😫 tired', '🥱 yawn', '😤 triumph huff', '😡 rage angry', '😠 angry mad',
    '🤬 cursing', '😈 smiling_imp devil', '💀 skull dead', '💩 poop', '🤡 clown', '👻 ghost', '👽 alien', '🤖 robot', '😺 smiley_cat',
    '😹 joy_cat', '😻 heart_eyes_cat',
  ],
  People: [
    '👋 wave hello hi', '🤚 raised_back_of_hand', '✋ raised_hand', '🖖 vulcan', '👌 ok_hand', '🤌 pinched_fingers', '✌️ v peace',
    '🤞 crossed_fingers luck', '🤟 love_you', '🤘 metal rock', '🤙 call_me', '👈 point_left', '👉 point_right', '👆 point_up',
    '👇 point_down', '☝️ index_up', '👍 thumbsup +1 yes like', '👎 thumbsdown -1 no', '✊ fist', '👊 punch', '🤛 left_fist',
    '🤜 right_fist', '👏 clap', '🙌 raised_hands hooray', '👐 open_hands', '🤲 palms_up', '🤝 handshake deal', '🙏 pray thanks please',
    '✍️ writing', '💅 nail_care', '💪 muscle strong', '🧠 brain', '👀 eyes look', '👁️ eye', '👅 tongue_out', '👄 lips', '🫶 heart_hands',
    '🙋 raising_hand', '🤷 shrug', '🤦 facepalm', '🙇 bow', '💁 tipping_hand', '🙅 no_gesture', '🙆 ok_gesture', '🧑‍💻 technologist coder',
    '🧑‍🎨 artist', '🧑‍🚀 astronaut', '🥷 ninja', '🧙 mage wizard', '🧛 vampire', '🧟 zombie',
  ],
  Nature: [
    '🐶 dog puppy', '🐱 cat kitty', '🐭 mouse', '🐹 hamster', '🐰 rabbit bunny', '🦊 fox', '🐻 bear', '🐼 panda', '🐨 koala', '🐯 tiger',
    '🦁 lion', '🐮 cow', '🐷 pig', '🐸 frog', '🐵 monkey', '🙈 see_no_evil', '🙉 hear_no_evil', '🙊 speak_no_evil', '🐔 chicken',
    '🐧 penguin', '🐦 bird', '🦆 duck', '🦉 owl', '🦇 bat', '🐺 wolf', '🐴 horse', '🦄 unicorn', '🐝 bee', '🐛 bug', '🦋 butterfly',
    '🐌 snail', '🐞 ladybug', '🐢 turtle', '🐍 snake', '🦖 t_rex dinosaur', '🐙 octopus', '🦑 squid', '🦀 crab', '🐠 fish', '🐬 dolphin',
    '🐳 whale', '🦈 shark', '🌵 cactus', '🎄 christmas_tree', '🌲 evergreen tree', '🌴 palm_tree', '🌱 seedling', '🌿 herb', '🍀 four_leaf_clover luck',
    '🍁 maple_leaf', '🍂 fallen_leaf autumn', '🌷 tulip', '🌹 rose', '🌻 sunflower', '🌸 cherry_blossom', '🌞 sun_with_face', '🌝 full_moon_face',
    '🌙 crescent_moon', '⭐ star', '🌟 glowing_star', '✨ sparkles', '⚡ zap lightning', '🔥 fire lit hot', '🌈 rainbow', '☀️ sunny',
    '⛅ partly_sunny', '🌧️ rain', '❄️ snowflake', '☃️ snowman', '🌊 wave ocean', '💧 droplet', '🌍 earth globe',
  ],
  Food: [
    '🍏 green_apple', '🍎 apple', '🍐 pear', '🍊 orange tangerine', '🍋 lemon', '🍌 banana', '🍉 watermelon', '🍇 grapes', '🍓 strawberry',
    '🫐 blueberries', '🍒 cherries', '🍑 peach', '🥭 mango', '🍍 pineapple', '🥥 coconut', '🥝 kiwi', '🍅 tomato', '🥑 avocado',
    '🌶️ hot_pepper spicy', '🌽 corn', '🥕 carrot', '🥐 croissant', '🥯 bagel', '🍞 bread', '🧀 cheese', '🥚 egg', '🍳 cooking',
    '🥞 pancakes', '🥓 bacon', '🍔 hamburger burger', '🍟 fries', '🍕 pizza', '🌭 hotdog', '🥪 sandwich', '🌮 taco', '🌯 burrito',
    '🍜 ramen noodles', '🍝 spaghetti', '🍣 sushi', '🍱 bento', '🍛 curry', '🍿 popcorn', '🍩 doughnut donut', '🍪 cookie',
    '🎂 birthday cake', '🍰 cake', '🧁 cupcake', '🍫 chocolate', '🍬 candy', '🍭 lollipop', '🍦 icecream', '☕ coffee', '🍵 tea',
    '🧋 bubble_tea boba', '🥤 cup_with_straw', '🍺 beer', '🍻 beers cheers', '🥂 champagne clink', '🍷 wine', '🧃 juice',
  ],
  Activities: [
    '⚽ soccer football', '🏀 basketball', '🏈 american_football', '⚾ baseball', '🎾 tennis', '🏐 volleyball', '🎱 8ball pool', '🏓 ping_pong',
    '🏸 badminton', '🥅 goal', '⛳ golf', '🏹 bow_and_arrow', '🎣 fishing', '🥊 boxing', '🛹 skateboard', '⛸️ ice_skate', '🎿 ski',
    '🏆 trophy win', '🥇 first_place gold', '🥈 second_place', '🥉 third_place', '🏅 medal', '🎖️ military_medal', '🎮 video_game gaming controller',
    '🕹️ joystick', '🎲 game_die dice', '🧩 puzzle', '♟️ chess', '🎯 dart bullseye', '🎳 bowling', '🎨 art palette', '🎬 clapper movie',
    '🎤 microphone sing', '🎧 headphones music', '🎼 musical_score', '🎹 piano', '🥁 drum', '🎸 guitar', '🎺 trumpet', '🎻 violin',
    '🎉 tada party celebrate', '🎊 confetti', '🎈 balloon', '🎁 gift present', '🎀 ribbon', '🎃 jack_o_lantern halloween', '🎆 fireworks',
  ],
  Travel: [
    '🚗 car', '🚕 taxi', '🚌 bus', '🏎️ race_car', '🚓 police_car', '🚑 ambulance', '🚒 fire_engine', '🚲 bike bicycle', '🛵 scooter',
    '🏍️ motorcycle', '🚂 train', '✈️ airplane plane', '🚀 rocket launch ship', '🛸 ufo', '🚁 helicopter', '⛵ sailboat', '🚢 ship',
    '⚓ anchor', '🗺️ map', '🧭 compass', '🏔️ mountain_snow', '⛰️ mountain', '🌋 volcano', '🏕️ camping', '🏖️ beach', '🏝️ island',
    '🏠 house home', '🏡 house_garden', '🏢 office', '🏰 castle', '🗼 tower', '🗽 statue_of_liberty', '⛺ tent', '🌃 night_city',
    '🌅 sunrise', '🌄 sunrise_mountains', '🌇 sunset', '🌉 bridge_night', '🎡 ferris_wheel', '🎢 roller_coaster',
  ],
  Objects: [
    '⌚ watch', '📱 iphone phone mobile', '💻 computer laptop', '⌨️ keyboard', '🖥️ desktop', '🖱️ mouse_computer', '💾 floppy save',
    '💿 cd', '📷 camera', '🎥 movie_camera', '📺 tv', '📻 radio', '🔋 battery', '🔌 plug', '💡 bulb idea', '🔦 flashlight', '🕯️ candle',
    '📚 books', '📖 book', '📝 memo note', '✏️ pencil', '🖊️ pen', '📌 pushpin pin', '📎 paperclip', '✂️ scissors', '🗂️ dividers',
    '📅 calendar date', '📈 chart_up stonks', '📉 chart_down', '📊 bar_chart', '📦 package box', '✉️ envelope email', '📨 incoming_envelope',
    '🔒 lock', '🔓 unlock', '🔑 key', '🔨 hammer', '🛠️ tools', '⚙️ gear settings', '🧪 test_tube', '🔬 microscope', '🔭 telescope',
    '💊 pill', '🩹 bandage', '🧹 broom', '🛒 shopping_cart', '💰 moneybag', '💸 money_wings', '💳 credit_card', '💎 gem diamond',
    '⏰ alarm_clock', '⏳ hourglass', '🔔 bell', '📣 mega loudspeaker', '🏷️ label tag', '🧲 magnet', '🪄 magic_wand',
  ],
  Symbols: [
    '❤️ heart love red_heart', '🧡 orange_heart', '💛 yellow_heart', '💚 green_heart', '💙 blue_heart', '💜 purple_heart', '🖤 black_heart',
    '🤍 white_heart', '🤎 brown_heart', '💔 broken_heart', '❣️ heart_exclamation', '💕 two_hearts', '💞 revolving_hearts', '💓 heartbeat',
    '💗 heartpulse', '💖 sparkling_heart', '💘 cupid', '💝 gift_heart', '💯 100 hundred perfect', '💢 anger', '💥 boom collision',
    '💫 dizzy_star', '💦 sweat_drops', '💨 dash', '💬 speech_balloon', '💭 thought_balloon', '💤 zzz sleep', '✅ white_check_mark done yes',
    '☑️ ballot_box_with_check', '✔️ heavy_check_mark check', '❌ x cross no', '❎ negative_squared_cross', '➕ plus heavy_plus',
    '➖ minus', '➗ divide', '❓ question', '❔ grey_question', '❗ exclamation', '‼️ bangbang', '⁉️ interrobang', '⚠️ warning',
    '🚫 no_entry_sign forbidden', '⛔ no_entry', '♻️ recycle', '🔴 red_circle', '🟠 orange_circle', '🟡 yellow_circle', '🟢 green_circle',
    '🔵 blue_circle', '🟣 purple_circle', '⚫ black_circle', '⚪ white_circle', '🔺 red_triangle', '🔻 red_triangle_down', '🏳️ white_flag',
    '🏴 black_flag', '🏁 checkered_flag finish', '🚩 red_flag', '🏳️‍🌈 rainbow_flag pride', '🆗 ok', '🆕 new', '🆒 cool_button',
    '🆙 up', '🔝 top', '🔜 soon', '♾️ infinity', '🎵 musical_note', '🎶 notes music',
  ],
};

export interface EmojiEntry {
  emoji: string;
  name: string;
  keywords: string[];
  category: string;
}

export const EMOJI_CATEGORIES = Object.keys(RAW);

export const EMOJIS: EmojiEntry[] = Object.entries(RAW).flatMap(([category, entries]) =>
  entries.map((entry) => {
    const [emoji, name, ...keywords] = entry.split(' ');
    return { emoji: emoji!, name: name!, keywords, category };
  }),
);

const byName = new Map<string, string>();
for (const e of EMOJIS) {
  byName.set(e.name, e.emoji);
  // Allow a few common aliases (e.g. :+1:, :heart:, :lol:) to resolve too.
  for (const k of e.keywords) if (!byName.has(k)) byName.set(k, e.emoji);
}

export function emojiByName(name: string): string | undefined {
  return byName.get(name.toLowerCase());
}

export function searchEmoji(query: string, limit = 60): EmojiEntry[] {
  const q = query.trim().toLowerCase().replace(/^:|:$/g, '');
  if (!q) return EMOJIS.slice(0, limit);
  const starts: EmojiEntry[] = [];
  const contains: EmojiEntry[] = [];
  for (const e of EMOJIS) {
    if (e.name.startsWith(q) || e.keywords.some((k) => k.startsWith(q))) starts.push(e);
    else if (e.name.includes(q) || e.keywords.some((k) => k.includes(q))) contains.push(e);
  }
  return [...starts, ...contains].slice(0, limit);
}

export const QUICK_REACTIONS = ['👍', '❤️', '😂', '🔥', '🎉', '👀'];

const RECENT_KEY = 'clanfire:recentEmoji';

export function recentEmoji(): string[] {
  try {
    return (JSON.parse(localStorage.getItem(RECENT_KEY) ?? '[]') as string[]).slice(0, 16);
  } catch {
    return [];
  }
}

export function rememberEmoji(emoji: string) {
  try {
    const next = [emoji, ...recentEmoji().filter((e) => e !== emoji)].slice(0, 16);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}
